// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/adiz.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/adiz/adiz.js';

mount([g0]);
